import {
  MatchmakingV2MessageType,
  generateMatchmakingV2Message,
} from '@playcastdotio/Messaging';
import { sendMessage } from '../../../api/modules/realtimeMessaging';
import { profileState, matchmakeToPublicMachineState } from '../../../api/stores/lobbyStores';
import { MatchmakingDialect } from './MatchmakingDialect';

export class MatchmakingV2Dialect implements MatchmakingDialect {
  readonly version = 'v2' as const;

  private activeMatchRequestId?: string;

  sendCreateRequest(campaignId: string, geohash?: string): void {
    const displayName = profileState.currentState.profile?.displayName || '';
    const matchmakeToPublicMachine = matchmakeToPublicMachineState.currentState.matchmakeToPublicMachine;

    const msg = generateMatchmakingV2Message(
      MatchmakingV2MessageType.MATCHMAKING_V2_CREATE_MATCH_REQUEST,
      {
        playerInfo: { displayName, geohash },
        campaignId,
        matchmakeToPublicMachine,
        sessionPreset: {
          authRequired: false,
          defaultPlayerSettings: { gamepad: true, keyboard: false, mouse: false },
        },
      },
    );
    sendMessage(msg as any);
  }

  sendDestroyRequest(requestId: string): void {
    if (!requestId) return;
    const msg = generateMatchmakingV2Message(
      MatchmakingV2MessageType.MATCHMAKING_V2_LEAVE_MATCH_REQUEST,
      { matchRequestId: requestId, playerId: '' },
    );
    sendMessage(msg as any);
  }

  sendQueueRequest(requestId: string): void {
    if (!requestId) return;
    const msg = generateMatchmakingV2Message(
      MatchmakingV2MessageType.MATCHMAKING_V2_ADD_TO_QUEUE,
      { matchRequestId: requestId },
    );
    sendMessage(msg as any);
  }

  setActiveMatchRequestId(id: string): void {
    this.activeMatchRequestId = id;
  }

  getActiveMatchRequestId(): string | undefined {
    return this.activeMatchRequestId;
  }
}
